module.exports = __webpack_public_path__ + "static/media/blog-personalization-feedback.f52d9109.jpg";